<p>
  multi-input-step works!
</p>
